import styled from "styled-components";

export const LinkSidebarContainer = styled.div`
  padding: 10px 0px;
`;

export const SpinnerContainer = styled.div`
  display: grid;
  place-content: center;
  margin-top: 25px;
`;

export const ListItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px 0px 0px;
`;

export const SearchSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const ListItem = styled.div`
  display: grid;
  grid-template-columns: 3fr 1.5fr;
  column-gap: 10px;
  align-items: center;
  border-radius: 3px;
  padding: 6px 0;
  background-color: ${({ isSelected }) =>
    isSelected ? "rgba(7, 20, 90, 0.1)" : "transparent"};

  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "default")};

  &:hover {
    background-color: ${({ isClickable }) =>
      isClickable ? "rgba(7, 20, 90, 0.05)" : "transparent"};
  }

  &:active {
    background-color: ${({ isClickable }) =>
      isClickable ? "rgba(7, 20, 90, 0.1)" : "transparent"};
  }
`;

export const HeaderLabels = styled.div`
  color: ${({ theme }) => theme.text.text};
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  opacity: 0.5;
`;

const Span = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
`;

export const ListTitle = styled(Span)`
  color: ${({ theme }) => theme.text.link};
  font-weight: 400;
  line-height: 16px;
  user-select: none;
`;

export const ListSpace = styled(Span)`
  color: ${({ theme }) => theme.text.title};
  user-select: none;
`;

export const PrimaryButton = styled.div`
  padding: 2px 30px 0;
  height: 30px;
  background-color: ${({ theme }) => theme.text.title};
  border-radius: 16px;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.text.inverse};
  white-space: nowrap;
  display: grid;
  place-content: center;
  cursor: pointer;
  font-family: "PP Formula";

  &:hover {
    opacity: 0.85;
  }
`;
